module.exports = __webpack_public_path__ + "static/img/20.9730826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/20.jpg
// module id = c5u9
// module chunks = 16